import { useT } from '../context/useT';
import style from './style.module.scss';

/**
 * Static "Meal deals" placeholder for the simulated home page,
 * matching the CTCAN-117 Figma. The data is hard-coded for now —
 * meal deals don't have a backend feed yet, so the section exists
 * primarily so CMS users see the same layout the mobile app will
 * render once that feed lands.
 */
export const PreviewMealDeals = () => {
    const t = useT();
    return (
        <div className={style.container}>
            <div className={style.badges}>
                <span
                    className={`${style.badge} ${style.badge_orange}`}
                    aria-hidden
                >
                    5$
                </span>
                <span
                    className={`${style.badge} ${style.badge_red}`}
                    aria-hidden
                >
                    6$
                </span>
            </div>
            <div className={style.text}>
                <h3 className={style.title}>{t.home.mealDeals}</h3>
                <p className={style.subtitle}>{t.home.mealDealsValidity}</p>
            </div>
        </div>
    );
};
